module.exports = __webpack_public_path__ + "img/Phone.9b0df2be.svg";